import { AfterViewInit, Component, ViewChild } from '@angular/core';
import { NavigationEnd, Router, RouterOutlet } from '@angular/router';
import { filter } from 'rxjs';
import { SpinnerComponent } from "./core/components/spinner/spinner.component";
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { LoaderInterceptor } from './core/interceptors/loader.interceptor';
import { ToastComponent } from "./shared/components/toast/toast.component";
import { ToastService } from './shared/services/toast/toast.service';
import { SessionPingService } from './shared/services/session/session-ping.service';
import { environment } from '../environments/environment';

@Component({
  selector: 'app-root',
  standalone:true,
  imports: [RouterOutlet, SpinnerComponent, ToastComponent],
  providers: [
    {
      provide: HTTP_INTERCEPTORS,
      useClass: LoaderInterceptor,
      multi: true
    }
  ],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss'
})
export class AppComponent implements AfterViewInit {
  @ViewChild(ToastComponent) toastComponent!: ToastComponent;
  @ViewChild(SpinnerComponent) spinnerComponent?: SpinnerComponent;
  title = 'portal-vivest-center';

  constructor(
    private toastService: ToastService,
    private router: Router,
    private sessionPing: SessionPingService,
  ) {
    console.log(environment.ambiente);

    // Liga ou desliga o ping de sessão a cada navegação: cobre o login, o logout
    // e a abertura do app com sessão já existente.
    this.router.events
      .pipe(filter((evento) => evento instanceof NavigationEnd))
      .subscribe(() => this.sessionPing.sincronizar());
    this.sessionPing.sincronizar();
  }
  ngAfterViewInit(): void {
    this.toastService.setToastComponent(this.toastComponent);
  }
}
